/**
 * Dock Quantity Selector
 *
 * Keeps the custom pack cards in sync with the selected Shopify variant.
 * The cards select a variant and provide the price source for the floating
 * PDP buy card, including Intelligems-adjusted DOM prices.
 */
(function () {
  var selectors = Array.prototype.slice.call(document.querySelectorAll('.dock-selector[data-section-id]'));
  if (!selectors.length) return;

  var starterTreatmentActive = document.documentElement.classList.contains('ig-dock-selector-starter-kit');
  var floatingSyncPendingBySection = {};

  updateBundleDeadlines();
  selectors.forEach(bindSelector);
  syncVisibleSelectors(false);

  document.addEventListener('flow:dock-selector-treatment-changed', function () {
    syncVisibleSelectors(true);
  });

  if (window.MutationObserver) {
    new MutationObserver(function () {
      var nextStarterTreatmentActive = document.documentElement.classList.contains('ig-dock-selector-starter-kit');
      if (nextStarterTreatmentActive === starterTreatmentActive) return;

      starterTreatmentActive = nextStarterTreatmentActive;
      syncVisibleSelectors(true);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  function bindSelector(container) {
    var sectionId = container.dataset.sectionId;
    var productUrl = container.dataset.productUrl;
    var cards = container.querySelectorAll('.dock-card[data-variant-id]');

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (!isSelectorVisible(container) || !isCardVisible(card)) return;

        normalizeSelection(productUrl, sectionId, card, {
          forceRefresh: true,
          publishSelection: true,
        });
      });
    });

    observePriceSurface(container, sectionId);
  }

  function updateBundleDeadlines() {
    document.querySelectorAll('[data-dock-bundle-deadline]').forEach(function (element) {
      var offsetHours = Number.parseInt(element.dataset.deadlineOffsetHours || '48', 10);
      var template = element.dataset.deadlineTemplate || 'Limited bundle offer, ends on [date]';
      var deadline = new Date(Date.now() + (Number.isFinite(offsetHours) ? offsetHours : 48) * 60 * 60 * 1000);
      var dateText = new Intl.DateTimeFormat(undefined, {
        month: 'short',
        day: 'numeric',
      }).format(deadline);

      element.textContent = template.replace('[date]', dateText);
    });
  }

  function syncVisibleSelectors(preferDefault) {
    selectors.forEach(function (container) {
      if (!isSelectorVisible(container)) return;
      syncSelector(container, preferDefault);
    });
  }

  function syncSelector(container, preferDefault) {
    var sectionId = container.dataset.sectionId;
    var productUrl = container.dataset.productUrl;
    var defaultVariantId = container.dataset.defaultVariantId;
    var cards = container.querySelectorAll('.dock-card[data-variant-id]');
    var visibleCards = getVisibleCards(cards);
    var activeCard = getActiveCard(visibleCards);
    var useDefault =
      preferDefault || (container.classList.contains('dock-selector--starter-kit') && !getUrlVariantId());
    var targetVariantId = useDefault ? defaultVariantId : getCurrentVariantId(sectionId);
    var currentCard = getCardByVariantId(visibleCards, targetVariantId);
    var fallbackCard = getCardByVariantId(visibleCards, defaultVariantId) || activeCard || visibleCards[0] || null;

    if (currentCard) {
      normalizeSelection(productUrl, sectionId, currentCard, {
        publishSelection: activeCard !== currentCard || String(getCurrentVariantId(sectionId)) !== String(currentCard.dataset.variantId),
      });
    } else if (fallbackCard) {
      normalizeSelection(productUrl, sectionId, fallbackCard, {
        publishSelection: true,
      });
    }
  }

  function normalizeSelection(productUrl, sectionId, card, options) {
    options = options || {};
    var variantId = card.dataset.variantId;
    var dockQuantity = card.dataset.dockQuantity || '1';
    var container = card.closest('.dock-selector');
    var currentVariantId = getCurrentVariantId(sectionId);

    if (!variantId) return;

    syncCardState(container.querySelectorAll('.dock-card[data-variant-id]'), card);
    syncFloatingBuyCardFromCard(sectionId, card);
    syncVariantInputs(sectionId, variantId);
    syncQuantityInputs(sectionId, dockQuantity);
    if (options.publishSelection) {
      publishDockSelection(sectionId, variantId, dockQuantity);
    }
    if (options.forceRefresh || String(currentVariantId) !== String(variantId)) {
      syncUrl(variantId);
      fetchSectionState(productUrl, sectionId, variantId);
    }
  }

  function syncCardState(cards, activeCard) {
    cards.forEach(function (card) {
      card.classList.toggle('is-active', card === activeCard);
    });
  }

  function observePriceSurface(container, sectionId) {
    var priceSurface = container.querySelector('.dock-cards');
    if (!window.MutationObserver || !priceSurface) return;

    new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        return mutation.type === 'characterData' || mutation.type === 'childList' || mutation.attributeName === 'hidden';
      });

      if (shouldSync) {
        requestFloatingBuyCardSync(sectionId);
      }
    }).observe(priceSurface, {
      attributes: true,
      attributeFilter: ['hidden'],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function requestFloatingBuyCardSync(sectionId) {
    if (!sectionId || floatingSyncPendingBySection[sectionId]) return;

    floatingSyncPendingBySection[sectionId] = true;

    function runSync() {
      floatingSyncPendingBySection[sectionId] = false;
      syncFloatingBuyCardFromActiveCard(sectionId);
    }

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(runSync);
    } else {
      window.setTimeout(runSync, 0);
    }
  }

  function syncFloatingBuyCardFromActiveCard(sectionId) {
    var selector = getVisibleSelector(sectionId);
    if (!selector) return;

    var visibleCards = getVisibleCards(selector.querySelectorAll('.dock-card[data-variant-id]'));
    var activeCard = getActiveCard(visibleCards) || visibleCards[0] || null;

    syncFloatingBuyCardFromCard(sectionId, activeCard);
  }

  function syncFloatingBuyCardFromCard(sectionId, card) {
    var button = document.getElementById('PdpFloatingBuyCardSubmit-' + sectionId);
    if (!button || !card) return;

    var priceSource = card.querySelector('[data-price-kind="price"]');
    var compareSource = card.querySelector('[data-price-kind="compare"]');
    var priceDestination = button.querySelector('[data-floating-buy-card-price]');
    var compareDestination = button.querySelector('[data-floating-buy-card-compare]');
    var countDestination = button.querySelector('[data-floating-buy-card-count]');
    var variantId = card.dataset.variantId || '';

    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML.trim();
      syncPriceAttributes(priceDestination, priceSource, variantId);
    }

    if (compareDestination) {
      if (compareSource && !compareSource.hidden && compareSource.textContent.trim()) {
        compareDestination.innerHTML = compareSource.innerHTML.trim();
        compareDestination.hidden = false;
        syncPriceAttributes(compareDestination, compareSource, variantId);
      } else {
        compareDestination.innerHTML = '';
        compareDestination.hidden = true;
      }
    }

    if (countDestination) {
      countDestination.textContent = card.dataset.dockCount || card.dataset.dockQuantity || '';
    }
  }

  function syncPriceAttributes(destination, source, fallbackVariantId) {
    var productId = source.getAttribute('data-product-id');
    var variantId = source.getAttribute('data-variant-id') || fallbackVariantId;

    if (productId) {
      destination.setAttribute('data-product-id', productId);
    } else {
      destination.removeAttribute('data-product-id');
    }

    if (variantId) {
      destination.setAttribute('data-variant-id', variantId);
    } else {
      destination.removeAttribute('data-variant-id');
    }
  }

  function getVisibleSelector(sectionId) {
    return selectors.find(function (container) {
      return String(container.dataset.sectionId) === String(sectionId) && isSelectorVisible(container);
    }) || null;
  }

  function getActiveCard(cards) {
    return [].find.call(cards, function (card) {
      return card.classList.contains('is-active');
    }) || null;
  }

  function getVisibleCards(cards) {
    return [].filter.call(cards, function (card) {
      return isCardVisible(card);
    });
  }

  function getCardByVariantId(cards, variantId) {
    if (!variantId) return null;

    return [].find.call(cards, function (card) {
      return String(card.dataset.variantId) === String(variantId);
    }) || null;
  }

  function isCardVisible(card) {
    if (!card) return false;

    return card.offsetParent !== null;
  }

  function isSelectorVisible(container) {
    if (!container) return false;

    return container.offsetParent !== null;
  }

  function getUrlVariantId() {
    try {
      return new URL(window.location.href).searchParams.get('variant');
    } catch (error) {
      return null;
    }
  }

  function getCurrentVariantId(sectionId) {
    var variantInput = document.querySelector(
      '#ProductInfo-' + sectionId + ' input.product-variant-id, #product-form-' + sectionId + ' input[name="id"]'
    );

    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    return getUrlVariantId();
  }

  function publishDockSelection(sectionId, variantId, dockQuantity) {
    document.dispatchEvent(
      new CustomEvent('flow:dock-selection-changed', {
        detail: {
          sectionId: String(sectionId),
          variantId: String(variantId),
          dockQuantity: String(dockQuantity),
        },
      })
    );
  }

  function syncVariantInputs(sectionId, variantId) {
    document
      .querySelectorAll(
        '#ProductInfo-' +
          sectionId +
          ' input.product-variant-id, #ProductInfo-' +
          sectionId +
          ' #product-form-installment-' +
          sectionId +
          ' input[name="id"]'
      )
      .forEach(function (input) {
        input.value = variantId;
        input.disabled = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  }

  function syncQuantityInputs(sectionId, quantity) {
    document
      .querySelectorAll(
        '#ProductInfo-' +
          sectionId +
          ' product-form input[name="quantity"], #Quantity-' +
          sectionId
      )
      .forEach(function (input) {
        input.value = quantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
  }

  function syncUrl(variantId) {
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  function fetchSectionState(productUrl, sectionId, variantId) {
    if (!productUrl) return;

    var requestUrl = productUrl + '?variant=' + variantId + '&section_id=' + sectionId;

    fetch(requestUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        syncNodeById(doc, sectionId, 'price', ['data-product-id', 'data-variant-id']);
        syncNodeById(doc, sectionId, 'Inventory');
        syncNodeById(doc, sectionId, 'Sku');
        syncNodeById(doc, sectionId, 'Volume');
        syncNodeById(doc, sectionId, 'Price-Per-Item');
        syncNodeById(doc, sectionId, 'Volume-Note');
        syncButtonState(doc, 'ProductSubmitButton-' + sectionId);
        syncButtonState(doc, 'PdpFloatingBuyCardSubmit-' + sectionId);
        syncVariantPicker(doc, sectionId);
        syncPickupAvailability(doc, sectionId);
        syncFloatingBuyCardFromActiveCard(sectionId);
      })
      .catch(function (error) {
        console.error('[dock-selector] Section fetch failed:', error);
      });
  }

  function syncNodeById(doc, sectionId, baseId, attributes) {
    var source = doc.getElementById(baseId + '-' + sectionId);
    var destination = document.getElementById(baseId + '-' + sectionId);
    if (!source || !destination) return;

    destination.innerHTML = source.innerHTML;
    destination.className = source.className;

    (attributes || []).forEach(function (attribute) {
      var value = source.getAttribute(attribute);
      if (value === null) {
        destination.removeAttribute(attribute);
      } else {
        destination.setAttribute(attribute, value);
      }
    });
  }

  function syncButtonState(doc, buttonId) {
    var source = doc.getElementById(buttonId);
    var destination = document.getElementById(buttonId);
    if (!source || !destination) return;

    destination.innerHTML = source.innerHTML;
    destination.classList.remove('loading');

    if (source.hasAttribute('disabled')) {
      destination.setAttribute('disabled', 'disabled');
    } else {
      destination.removeAttribute('disabled');
    }

    var ariaDisabled = source.getAttribute('aria-disabled');
    if (ariaDisabled === null) {
      destination.removeAttribute('aria-disabled');
    } else {
      destination.setAttribute('aria-disabled', ariaDisabled);
    }
  }

  function syncVariantPicker(doc, sectionId) {
    var source = doc.querySelector('#ProductInfo-' + sectionId + ' variant-selects');
    var destination = document.querySelector('#ProductInfo-' + sectionId + ' variant-selects');
    if (!source || !destination) return;

    destination.innerHTML = source.innerHTML;
  }

  function syncPickupAvailability(doc, sectionId) {
    var variant = getSelectedVariant(doc);
    var pickupAvailability = document.querySelector('#ProductInfo-' + sectionId + ' pickup-availability');
    if (!pickupAvailability || !variant || typeof pickupAvailability.update !== 'function') return;

    pickupAvailability.dataset.variantId = variant.id;
    pickupAvailability.update(variant);
  }

  function getSelectedVariant(doc) {
    var selectedVariant = doc.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariant) return null;

    try {
      return JSON.parse(selectedVariant.textContent);
    } catch (error) {
      console.error('[dock-selector] Invalid selected variant payload:', error);
      return null;
    }
  }
})();
